import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ItemHierarchyManagerService {

  constructor(private http: HttpClient) { }



  GetItemHierarchyList(): Observable<any> {
    return this.http.get<any>(`${environment.ItemHierarchyManager}/productHierarchyGetList`,)
      .pipe(map(response => {
        return response;
      }));
  }
  GetProductHierarchyList(): Observable<any> {
    return this.http.get<any>(`${environment.HierarchyManager}/productHierarchyMetadataGetList`,)
      .pipe(map(response => {
        return response;
      }));
  }

  AddUpdateItemHierarchyList(body): Observable<any> {
    return this.http.post<any>(`${environment.ItemHierarchyManager}/productHierarchyInsertOrUpdate`, body)
      .pipe(map(response => {
        return response;
      }));
  }

  ImportItemHierarchyManagerList(body) {
    return this.http.post(`${environment.ItemHierarchyManager}/productsHierarchyImport`, body)
      .pipe(map(data => {
        return data;
      }));
  }

  DeleteItemHierarchyRow(body): Observable<any> {
    return this.http.post<any>(`${environment.ItemHierarchyManager}/productHierarchyDelete`, body)
      .pipe(map(response => {
        return response;
      }));
  }


}
